import { render } from "./PerCircle.vue?vue&type=template&id=08d50388&scoped=true"
import script from "./PerCircle.vue?vue&type=script&lang=js"
export * from "./PerCircle.vue?vue&type=script&lang=js"

import "./PerCircle.vue?vue&type=style&index=0&id=08d50388&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d50388"]])

export default __exports__